/**
 * detail-page.js starts
 * Created by mac on 2019-02-13.
 */

$(function () {
  
  var $detailSliders = $('.detail-pic-sliders');
  if ($detailSliders.length) {
  
  }
  $detailSliders.each(function(){
    var $big = $(this).find('.pic-slider-big'),
        $nav = $(this).find('.pic-slider-nav');
    if ($big) {
      $big.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: $nav,
        prevArrow: slickButtons.prev,
        nextArrow: slickButtons.next,
      }).magnificPopup({
        type: 'image',
        delegate: 'a',
        removalDelay: 300,
        gallery: {
          enabled: true,
          tCounter: ''
        }
      });
    }
  
    if ($nav) {
      $nav.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        asNavFor: $big,
        focusOnSelect: true,
        prevArrow: slickButtons.prev,
        nextArrow: slickButtons.next,
        centerPadding: '0'
      });
    }
    
  });
  
  
});

/* detail-page.js ends */